import { render, staticRenderFns } from "./QueryError.vue?vue&type=template&id=471e32d9"
import script from "./QueryError.vue?vue&type=script&lang=js"
export * from "./QueryError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports